import React from 'react';
import { Modal } from 'antd';
import { StyledShortcutGrid, StyledShortcutItem, StyledShortcutKey } from './styled';

export interface KeyboardShortcut {
    keys: string[];
    description: string;
    category?: string;
}

const shortcuts: KeyboardShortcut[] = [
    { keys: ['Ctrl', 'S'], description: 'Download card', category: 'Actions' },
    { keys: ['⌘', 'S'], description: 'Download card (Mac)', category: 'Actions' },
    { keys: ['Ctrl', 'D'], description: 'Export card data', category: 'Actions' },
    { keys: ['⌘', 'D'], description: 'Export card data (Mac)', category: 'Actions' },
    { keys: ['Ctrl', 'E'], description: 'Import card data', category: 'Actions' },
    { keys: ['⌘', 'E'], description: 'Import card data (Mac)', category: 'Actions' },
    { keys: ['Ctrl', 'G'], description: 'Merge card data', category: 'Actions' },
    { keys: ['⌘', 'G'], description: 'Merge card data (Mac)', category: 'Actions' },
    { keys: ['Ctrl', 'Y'], description: 'View full size', category: 'View' },
    { keys: ['⌘', 'Y'], description: 'View full size (Mac)', category: 'View' },
    { keys: ['Tab'], description: 'Navigate between fields', category: 'Navigation' },
    { keys: ['Shift', 'Tab'], description: 'Navigate backwards', category: 'Navigation' },
    { keys: ['Esc'], description: 'Close modals', category: 'Navigation' },
];

interface KeyboardShortcutsModalProps {
    visible: boolean;
    onClose: () => void;
}

export const KeyboardShortcutsModal: React.FC<KeyboardShortcutsModalProps> = ({ visible, onClose }) => {
    const categories = Array.from(new Set(shortcuts.map(s => s.category || 'General')));

    return (
        <Modal
            title="Keyboard Shortcuts"
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={600}
            className="keyboard-shortcuts-modal"
        >
            {categories.map(category => (
                <div key={category} style={{ marginBottom: 'var(--space-6)' }}>
                    <h3 style={{ 
                        fontSize: 'var(--text-lg)', 
                        fontWeight: 'var(--font-semibold)',
                        color: 'var(--text-primary)',
                        marginBottom: 'var(--space-3)'
                    }}>
                        {category}
                    </h3>
                    <StyledShortcutGrid>
                        {shortcuts
                            .filter(s => (s.category || 'General') === category)
                            .map((shortcut, index) => (
                                <StyledShortcutItem key={index}>
                                    <div className="shortcut-keys">
                                        {shortcut.keys.map((key, i) => (
                                            <React.Fragment key={i}>
                                                <StyledShortcutKey>{key}</StyledShortcutKey>
                                                {i < shortcut.keys.length - 1 && (
                                                    <span className="shortcut-plus">+</span>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                    <div className="shortcut-description">
                                        {shortcut.description}
                                    </div>
                                </StyledShortcutItem>
                            ))}
                    </StyledShortcutGrid>
                </div>
            ))}
        </Modal>
    );
};
